import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import Droppable from 'owa-dnd/lib/components/Droppable';
import folderStore from 'owa-folders';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';
import { getFocusedOtherDropViewState, getFocusedFilterForTable, listViewStore, } from 'owa-mail-list-store';
import { isAllDefaultForFocusedInbox } from 'owa-mail-list-actions';
import { trace } from 'owa-trace';
import selectFocusedViewFilter from 'owa-mail-list-actions/lib/actions/selectFocusedViewFilter';
var styles = require('./FocusedInboxPivot.scss');
var classNames = require('classnames/bind').bind(styles);
var FocusedInboxPivot = /** @class */ (function (_super) {
    tslib_1.__extends(FocusedInboxPivot, _super);
    function FocusedInboxPivot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderFocusedOtherPivot = function (selectedKey) {
            // Note that we have to render Pivot control instead of conditional render the pivot item. This is a workaround because pivot control doesn't
            // support conditional rendering. Otherwise, the pivot item is boolean and will not render any pivot.
            return (React.createElement("div", { className: styles.focusedOtherContainer, onKeyDown: function (ev) { return _this.props.onKeyDown(ev, _this.props.tableViewId); } },
                React.createElement(Pivot, { className: styles.pivotContainer, styles: _this.calculateCustomPivotStyle, selectedKey: "" + selectedKey, onLinkClick: _this.onPivotItemClicked },
                    _this.renderFocusedPivot(selectedKey),
                    _this.renderOtherPivot(selectedKey))));
        };
        _this.renderInboxFocusedOtherPivot = function (selectedKey) {
            // Note that we have to render Pivot control instead of conditional render the pivot item. This is a workaround because pivot control doesn't
            // support conditional rendering. Otherwise, the pivot item is boolean and will not render any pivot.
            return (React.createElement("div", { className: styles.focusedOtherContainer, onKeyDown: function (ev) { return _this.props.onKeyDown(ev, _this.props.tableViewId); } },
                React.createElement(Pivot, { className: styles.pivotContainer, styles: _this.calculateCustomPivotStyle, selectedKey: "" + selectedKey, onLinkClick: _this.onPivotItemClicked },
                    _this.renderInboxPivot(selectedKey),
                    _this.renderFocusedPivot(selectedKey),
                    _this.renderOtherPivot(selectedKey))));
        };
        _this.renderInboxFocusedPivot = function (selectedKey) {
            // Note that we have to render Pivot control instead of conditional render the pivot item. This is a workaround because pivot control doesn't
            // support conditional rendering. Otherwise, the pivot item is boolean and will not render any pivot.
            return (React.createElement("div", { className: styles.focusedOtherContainer, onKeyDown: function (ev) { return _this.props.onKeyDown(ev, _this.props.tableViewId); } },
                React.createElement(Pivot, { className: styles.pivotContainer, styles: _this.calculateCustomPivotStyle, selectedKey: "" + selectedKey, onLinkClick: _this.onPivotItemClicked },
                    _this.renderInboxPivot(selectedKey),
                    _this.renderFocusedPivot(selectedKey))));
        };
        _this.renderInboxPivot = function (selectedKey) {
            var inboxFolder = folderStore.folderTable.get(folderNameToId('inbox'));
            return (React.createElement(PivotItem, { className: styles.pivotItem, linkText: inboxFolder.DisplayName, itemKey: 'inbox' }));
        };
        _this.renderFocusedPivot = function (selectedKey) {
            return (React.createElement(PivotItem, { linkText: strings.focusedViewFilterText, itemKey: 'focused', onRenderItemLink: function (link, defaultRenderer) {
                    return _this.renderDroppablePivot(link, defaultRenderer, 'focused', selectedKey);
                } }));
        };
        _this.renderOtherPivot = function (selectedKey) {
            return (React.createElement(PivotItem, { linkText: strings.otherViewFilterText, itemKey: 'other', onRenderItemLink: function (link, defaultRenderer) {
                    return _this.renderDroppablePivot(link, defaultRenderer, 'other', selectedKey);
                } }));
        };
        _this.calculateCustomPivotStyle = function () {
            return {
                link: styles.nonSelectedPivotLink,
                linkIsSelected: styles.selectedPivotLink,
                linkContent: styles.linkContent,
                text: styles.text,
            };
        };
        _this.renderDroppablePivot = function (link, defaultRenderer, pivotKey, selectedPivotKey) {
            var isCurrentPivotSelected = selectedPivotKey === pivotKey;
            var pivotStyle = classNames(styles.pivotItem, { pivotDropHint: _this.props.isSupportedItemTypeForDragDrop && !isCurrentPivotSelected }, { shouldShowOnDropHoverTreatment: _this.props.shouldShowOnDropHoverTreatment });
            return (React.createElement(Droppable, { classNames: pivotStyle, dropViewState: getFocusedOtherDropViewState(), onDrop: _this.props.onDrop, canDrop: _this.props.canDrop },
                defaultRenderer(link),
                _this.tryRenderUnseenCountBadge(selectedPivotKey, pivotKey)));
        };
        _this.onPivotItemClicked = function (item) {
            var focusedViewFilterToSelect = _this.convertPivotKeyToFocusedViewFilter(item.props.itemKey);
            selectFocusedViewFilter(focusedViewFilterToSelect, 'FocusedOtherPivot');
        };
        _this.tryRenderUnseenCountBadge = function (selectedPivotKey, pivotKey) {
            var allDefaultForFocusedInbox = isAllDefaultForFocusedInbox();
            if (allDefaultForFocusedInbox) {
                // When server flight AllDefaultForFocusedInbox is true, client has fallback logic to always show Inbox pivot, in which case
                // we do not show the unseen count
                return null;
            }
            if (selectedPivotKey === pivotKey) {
                return null;
            }
            return _this.props.unseenCountToDisplay ? (React.createElement("div", { className: styles.badgeContainer },
                React.createElement("p", { className: styles.unseenCount }, _this.props.unseenCountToDisplay))) : null;
        };
        return _this;
    }
    FocusedInboxPivot.prototype.render = function () {
        var allDefaultForFocusedInbox = isAllDefaultForFocusedInbox();
        var selectedKey = this.getKeyForSelectedFocusedViewFilter();
        if (allDefaultForFocusedInbox) {
            if (isMailFeatureEnabled('tri-inbox-focused-other-pivot')) {
                // Inbox, Focused, Other
                return this.renderInboxFocusedOtherPivot(selectedKey);
            }
            else if (isMailFeatureEnabled('tri-inbox-focused-pivot')) {
                // Inbox, Focused
                return this.renderInboxFocusedPivot(selectedKey);
            }
            else {
                // Fallback to the Inbox | Focused | Other as long as the server flight isAllDefaultForFocusedInbox is ON, because the session data is giving Inbox data.
                // This is to prevent the case if server and client configs are not in sync, which could happen during rolling out the experiment flights.
                return this.renderInboxFocusedOtherPivot(selectedKey);
            }
        }
        else {
            if (isMailFeatureEnabled('tri-inbox-focused-other-pivot') ||
                isMailFeatureEnabled('tri-inbox-focused-pivot')) {
                trace.warn('FocusedInboxPivot: server flight is not enabled.');
            }
            // Focused, Other
            return this.renderFocusedOtherPivot(selectedKey);
        }
    };
    /**
     * Convert the focused view filter to a string that used as the key in Pivot fabric component
     * We need to do this instead of just using the FocusedViewFilter value, because FocusedViewFilter.None(-1) is ignored by the Fabric Pivot
     */
    FocusedInboxPivot.prototype.getKeyForSelectedFocusedViewFilter = function () {
        var tableView = listViewStore.tableViews.get(this.props.tableViewId);
        var focusedFilterForTable = getFocusedFilterForTable(tableView);
        var selectedKey = '';
        switch (focusedFilterForTable) {
            case -1 /* None */:
                selectedKey = 'inbox';
                break;
            case 0 /* Focused */:
                selectedKey = 'focused';
                break;
            case 1 /* Other */:
                selectedKey = 'other';
                break;
        }
        return selectedKey;
    };
    /**
     * Convert pivot key string back to the focused view filter to select
     * @param key of the pivot component
     */
    FocusedInboxPivot.prototype.convertPivotKeyToFocusedViewFilter = function (key) {
        switch (key) {
            case 'focused':
                return 0 /* Focused */;
            case 'other':
                return 1 /* Other */;
            default:
            case 'inbox':
                return -1 /* None */;
        }
    };
    FocusedInboxPivot = tslib_1.__decorate([
        observer
    ], FocusedInboxPivot);
    return FocusedInboxPivot;
}(React.Component));
export default FocusedInboxPivot;
//# sourceMappingURL=FocusedInboxPivot.js.map